export default __webpack_public_path__ + "static/media/2109.8fb558cc.png";